import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './leaveStyle.css';
import config from '../../config.json';
import LeaveLabel from './LeaveLabel'

const apiUrl = config.apiUrl;

const LeaveApproved = () => {
    const [leaveData, setLeaveData] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        LeaveType: '',
        Duration: '',
        Remarks: '',
        Status: '',
    });

    const { leaveId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;
    useEffect(() => {
        const fetchLeaveData = async () => {
            if (!leaveId) return;

            setIsDisable(true);

            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${apiUrl}/Leave/${leaveId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch leave data');
                    setSuccessMessage('');
                    return;
                }

                const data = await response.json();
                setLeaveData({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    LeaveType: data.Details.LeaveType,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });

                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Failed to fetch leave data');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchLeaveData();
    }, []);

    const handleInputChange = (e) => {
        setLeaveData({ ...leaveData, [e.target.name]: e.target.value });
    };

    const handleForSubmit = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const { Remarks } = leaveData;

        const approvedLeave = {
            Remarks,
        };

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Leave/Approve/${leaveId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(approvedLeave),
            });

            const data = await response.json();

            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    setErrorMessage(data.Message);
                    setSuccessMessage('');
                    return
                }
            }

            setSuccessMessage(data.Message);
            setErrorMessage('');

            setIsDisable(false);

            navigate('/leave-list');
        } catch (error) {
            setErrorMessage('Error approval');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        LeaveType,
        Duration,
        Remarks,
        Status,
    } = leaveData;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasApprover) ? (
                <>
                    <h3>Approve Leave</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleForSubmit}>
                        <div className="row mt-4">
                            <LeaveLabel label="Transaction ID" value={TransactionID} />
                            <LeaveLabel label="Transaction Date" value={TransactionDate} />
                            <LeaveLabel label="Employee" value={Employee.Name} />
                            <LeaveLabel label="Leave Type" value={LeaveType} />
                            <LeaveLabel label="Date Start" value={DateStart} />
                            <LeaveLabel label="Date End" value={DateEnd} />
                            <LeaveLabel label="Duration" value={Duration} />
                            <LeaveLabel label="Status" value={Status} />
                            <div className="mb-2">
                                <label htmlFor="remarks" className="form-label bold-label">Remarks</label>
                                <input
                                    type="text"
                                    className="form-control custom-width"
                                    id="remarks"
                                    name="Remarks"
                                    value={Remarks}
                                    onChange={handleInputChange}
                                    maxLength={500}
                                />
                            </div>
                            <div className="mb-2">
                                <Link to="/leave-list" className="btn btn-secondary me-2">Back</Link>
                                {(userAccess.hasApprover || userAccess.hasAdmin) && (
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isDisable} // Disable the button based on the isApproving state
                                    >
                                        Approve
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default LeaveApproved;
